import { render, staticRenderFns } from "./dash-subscribers.vue?vue&type=template&id=31a8d8cd&"
import script from "./dash-subscribers.vue?vue&type=script&lang=js&"
export * from "./dash-subscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports